{
	"id": 7508,
	"moduleNumber": 8,
	"slug": "module-8",
	"kgNodeId": "module-8",
	"title": "Ethical Decision Making for the Professional Educator",
	"subtitle": "Synthesize ethical decision-making principles across professional practice scenarios.",
	"type": "lesson",
	"moduleKind": "lesson",
	"moduleKindLabel": "Lesson",
	"sourceStatus": "extracted_from_editorial_and_scenario_assets",
	"summary": "This module contains one scenario with three different outcomes and a five-question end-of-module knowledge check. It will take approximately 30 to 40 minutes to complete the entire module.",
	"estimatedDurationMinutes": 45,
	"activityCount": 1,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	},
	"learningObjectives": [
		"Differentiate between dispositional and regulatory frameworks and identify how each influences educators' decision making in real-world scenarios.",
		"Identify how educator actions can produce different short-term and long-term outcomes.",
		"Recognize that a single decision may cause multiple ethical principles to be compromised or upheld.",
		"Use ethical principles to evaluate educator responses to situations."
	],
	"flow": [
		"Module introduction.",
		"Multiple possible outcomes of an ethical scenario: The Ride Home.",
		"Outcome 1: Reflect, Explore, and Review.",
		"Outcome 2: Reflect, Explore, and Review.",
		"Outcome 3: Reflect, Explore, and Review.",
		"The Ride Home: Analysis.",
		"Module 8 summary and knowledge check."
	],
	"scenarios": [
		{
			"id": "module-8-the-ride-home",
			"title": "The Ride Home",
			"summary": "Learners evaluate three possible outcomes of an educator's decision to give a student a ride home, weighing short-term and long-term consequences against professional standards."
		}
	],
	"ethicalSituations": ["The Ride Home"],
	"sources": {
		"curriculum": null,
		"primary": null,
		"editorial": null,
		"transcripts": [],
		"videos": []
	}
}
